import { get_token} from "@/router";
import Navbar from "@/components/HomeNavBar/HomeNavBar.vue"
import AllPortals from "@/components/GetPortals/PortalsComponent.vue"
import CreateFeed from "@/components/CreateFeed/CreateFeed.vue"
import PortalMembers from "@/components/PortalMembers/PortalMembers.vue";
import PortalRequest from "@/components/GetPortalRequest/PortalRequestView.vue"
import SurveyView from "@/components/SurveysAndPolls/Survey.vue";
import DocumentApproval from "@/components/DocumentApproval/DocumentApproval.vue";
import DocumentWarehouse from "@/components/DocumentWarehouse/DocumentWarehouse.vue";
import ReportCommentModal from "@/components/ReportCommentModal/ReportCommentModal.vue";
import StickyNav from "@/components/BottomNavbar/StickyNavbar.vue";
import Comments from '@/components/Comments/Comments.vue';
import Swal from 'sweetalert2';

const GLOBAL_URL = process.env.VUE_APP_BACKEND_API_URL;

export default {
    components: {
        Navbar,
        AllPortals,
        CreateFeed,
        PortalMembers,
        PortalRequest,
        SurveyView,
        DocumentApproval,
        DocumentWarehouse,
        ReportCommentModal,
        StickyNav,
        Comments
    },
    data() {
        return {
            reports: [],
            expandedReports: [],
            current_date: this.get_formatted_date(),
            activeVoiceTab: 'your_feed',
            comment_modal_visible: false,
            user_id:null,
            activeCommentReportId: null,
           
        };
    },
    mounted() {
        this.filterReports();
        this.fetch_grouped_tags();
        this.user_id = this.get_user_id();
        this.token_exists = get_token();
    },
    methods: {
filteredCategoriesForReport(report) {
    // report.tags is the list of tags for this report (flat array)
    // this.categories is all categories with all tags globally

    if (!report.tags || !this.categories) return [];

    // Create a Set of tag IDs assigned to this report
    const reportTagIds = new Set(report.tags.map(t => t.id));

    // Filter categories and their tags by report's tags
    return this.categories
      .map(category => {
        const filteredTags = category.tags.filter(tag => reportTagIds.has(tag.id));
        return {
          name: category.name,
          tags: filteredTags
        };
      })
      .filter(category => category.tags.length > 0); // only categories with tags for report
  },
  handleAddComment({ report_id, newComment }) {
  const reportIndex = this.reports.findIndex(r => r.id === report_id);
  const report = this.reports.at(reportIndex); // ✅ safe accessor

  if (report) {
    report.comments = [newComment].concat(report.comments);
    this.reports = Array.from(this.reports); // ✅ reactivity trigger
  }
},
async submit_comment(report_id) {
  if (!this.token_exists) {
    this.$router.push('/sign_in_finale');
    return;
  }

  const comment_text = $("#comment_text_area").val();

  if (comment_text.trim() === "") {
    Swal.fire({
      icon: 'error',
      title: 'Please write a comment before submitting.',
      timer: 2000,
      showConfirmButton: false,
    });
    return;
  }

  const baseUrl = `${window.location.origin}${this.$route.path}?report_id=${report_id}`;
  this.commentText = "";
  $("#comment_text_area").val("");

  const request_data = {
    report_id,
    comment_text,
    base_url: baseUrl
  };

  const request_url = `${GLOBAL_URL}/portal_management/add_report_comment/`;

  $.ajax({
    url: request_url,
    method: 'POST',
    headers: {
      'Authorization': `Token ${this.getToken()}`,
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(request_data),
    success: (response) => {
  if (response.status === "success") {
    const newComment = response.data.comment_data;

    // ✅ Find the report in parent state
    const reportIndex = this.reports.findIndex(r => r.id === report_id);
    const report = this.reports.at(reportIndex); // safer access

    if (report) {
      // ✅ Replace comments array so Vue notices the change
      report.comments = [newComment].concat(report.comments);

      // ✅ Increment total_comments
      report.total_comments = (report.total_comments || 0) + 1;

      // ✅ Replace parent reports array for top-level reactivity
      this.reports = Array.from(this.reports);
    }

    // Clear input
    this.commentText = "";
    $("#comment_text_area").val("");
  }
},
    error: () => {
      Swal.fire({
        icon: 'error',
        title: 'Could not add comment',
        text: 'Please try again later.',
        timer: 3000,
        showConfirmButton: false,
        position: 'bottom-end',
        toast: true
      });
    },
    complete: () => {
      this.isSubmitting = false;
    }
  });
},
  fetch_grouped_tags() {
  this.isLoading = true;

  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_tags/`,
    method: 'GET',
    headers: {
      'Authorization': `Token ${this.getToken()}`,
      'Content-Type': 'application/json'
    },
    success: (response) => {
      if (response.status === "success") {
        const tag_list = response.data.tags;

        // ✅ Use Map instead of plain object
        const grouped = new Map();

        tag_list.forEach(tag => {
          const categoryName = tag.tag_category.name;

          if (!grouped.has(categoryName)) {
            grouped.set(categoryName, []);
          }

          grouped.get(categoryName).unshift({
            id: tag.id,
            name: tag.name
          });
        });

        // Convert Map to array of category objects
        this.categories = Array.from(grouped.entries()).map(([name, tags]) => ({
          name,
          tags
        }));

        this.all_tags_by_category = grouped;
        this.categoryOptions = ['all', ...Array.from(grouped.keys()).sort()];
      }
    },
    complete: () => {
      this.isLoading = false;
    }
  });
},
      getToken() {
        return get_token();
      },
        get_formatted_date() {
         const options = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' };
         return new Date().toLocaleDateString('en-GB', options);
        }, 
        getIdFromURL(param) {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get(param);
        },
         async filterReports() {
  this.is_report_loading = true;
  this.reports = [];

  const report_id = this.$route.params.report_id;
  try {
    const res = await fetch(
      `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_report_by_id/`,
      {
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ report_id }),
      }
    );

    const data = await res.json();
    const response = data.reports || [];
    this.reports = response;

  } catch (error) {
    console.error('Error fetching reports:', error);
  } finally {
    this.is_report_loading = false;
    this.hasLoadedOnce = true;
  }
},
        baseUrl(post, type) {
            const baseUrl = `${window.location.origin}${this.$route.path}`;
            // Dynamically build the URL based on the type (either 'hub' or 'report')
            if (type === 'exchange_hub') {
            return `${baseUrl}?hub_id=${post.id}`;
            } else if (type === 'report') {
            return `${baseUrl}?report_id=${post.id}`;
            }
            return baseUrl
        },
        copyReportLinkToClipboard(report) {
        const link = this.baseUrl(report, 'report');
        navigator.clipboard.writeText(link).then(() => {
            this.showToast('Link copied to clipboard!');
        })
        },
        display_comment_modal(report_data) {
        this.report_data = report_data;
        this.comment_modal_visible = true;
        },
        hide_comment_comment() {
        this.report_data = {};
        this.comment_modal_visible = false;
        },
        likeReport(report) {
        if (!this.token_exists) {
            this.$router.push('/sign_in_finale');
            return;
        }
        const reportId = report.id;
        $.ajax({
            type: "POST",
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/add_report_like/`,
            contentType: "application/json",
            headers: {
            'Authorization': `Token ${this.getToken()}`,
            },
            data: JSON.stringify({ report_id: reportId }),
            success: (response) => {
            if (response.status === "success") {

            const liked_report = this.reports.find(like => like.id === reportId);
            if (liked_report) {
                liked_report.like_count++;
            }
                const likeButton = document.getElementById(`like-button${reportId}`);
                const likedButton = document.getElementById(`liked-button${reportId}`);


                if (likeButton) {
                likeButton.classList.add('d-none');
                }

                if (likedButton) {
                likedButton.classList.remove('d-none');
                }
            }
        }
      });
        },
        unlikeReport(report) {
      if (!this.token_exists) {
        this.$router.push('/sign_in_finale');
        return;
      }
      const reportId = report.id;
      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/add_report_like/`,
        contentType: "application/json",
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        data: JSON.stringify({ report_id: reportId }),
        success: (response) => {
          if (response.status === "success") {
            const likeButton = document.getElementById(`like-button${reportId}`);
            const likedButton = document.getElementById(`liked-button${reportId}`);

          const unliked_report = this.reports.find(like => like.id === report.id);
          if (unliked_report) {
            unliked_report.like_count--;
          }

            if (likeButton) {
              likeButton.classList.remove('d-none');
            }

            if (likedButton) {
              likedButton.classList.add('d-none');
            }
          }
        }
      });
    },
     get_user_id() {
      const user_id = localStorage.getItem('user_id') || '';
      return user_id;
  },
      copyReportLinkToClipboard(report) {
      const link = this.baseUrl(report, 'report');
      navigator.clipboard.writeText(link).then(() => {
        this.showToast('Link copied to clipboard!');
      })
    },
    showToast(message) {
    document.querySelector('#copyToast .toast-body').textContent = message;

    $('#copyToast').fadeIn(300).addClass('show');
    setTimeout(function() {
      $('#copyToast').fadeOut(300).removeClass('show');
    }, 3000); 
  },
  closeMenu(reportId) {
    const checkbox = document.getElementById('menu-open-' + reportId);
    if (checkbox) {
      checkbox.checked = false;
    }
  },
  getFileIcon(fileUrl) {
    if (fileUrl.includes('.pdf')) 
      return 'https://cdn-icons-png.flaticon.com/128/337/337946.png'; // PDF icon
    if (fileUrl.includes('.doc') || fileUrl.includes('.docx')) 
      return 'https://cdn-icons-png.flaticon.com/128/337/337932.png'; // Word icon
    if (fileUrl.includes('.xls') || fileUrl.includes('.xlsx')) 
      return 'https://cdn-icons-png.flaticon.com/128/337/337958.png'; // Excel icon
    if (fileUrl.includes('.ppt') || fileUrl.includes('.pptx')) 
      return 'https://cdn-icons-png.flaticon.com/128/337/337950.png'; // PowerPoint icon
    if (fileUrl.includes('.html') || fileUrl.includes('.htm')) 
      return 'https://cdn-icons-png.flaticon.com/128/732/732212.png'; // HTML icon
    return 'https://cdn-icons-png.flaticon.com/128/337/337940.png'; // Default file icon
  },
  getFileName(fileUrl) {
    const decodedUrl = decodeURIComponent(fileUrl);
    const cleanUrl = decodedUrl.split('?')[0];
    return cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1);
  },  
    },
}